// extracted by mini-css-extract-plugin
module.exports = {"gas-price":"gas-price_gas-price__25HLA","block":"gas-price_block__2w1HE","pricing":"gas-price_pricing__WOkUB","pba":"gas-price_pba__2Kopd","loading":"gas-price_loading__3YwJE"};